import type { WalletDetail, WalletLedgerEntry } from './types';

const partnerA = Object.freeze({
  id: '00000000-0000-4000-8000-000000000101',
  code: 'PARTNER-A',
  name: 'Partner A',
});

const agentA = Object.freeze({
  id: '00000000-0000-4000-8000-000000000201',
  code: 'AGENT-A',
  name: 'Agent A',
});

export const walletFixtures = Object.freeze<readonly WalletDetail[]>([
  {
    id: '00000000-0000-4000-8000-000000001001',
    partner: partnerA,
    memberId: '00000000-0000-4000-8000-000000000301',
    partnerUserId: 'partner-user-a',
    username: 'affiliate-a',
    agent: agentA,
    status: 'ACTIVE',
    currencyCode: 'THB',
    currencyMinorUnit: 2,
    availableBalance: '10250.000000',
    reservedBalance: '1500.000000',
    totalBalance: '11750.000000',
    lifetimeEarned: '15000.000000',
    lifetimeReversed: '250.000000',
    lifetimeAdjusted: '-500.000000',
    lifetimeWithdrawn: '2500.000000',
    lifetimeExpired: '0.000000',
    expiringBalance: '0.000000',
    nextExpiryAt: null,
    version: '42',
    lastEntryAt: '2026-07-22T08:00:00-04:00',
    reconciliation: { status: 'MATCHED', checkedAt: '2026-07-22T21:00:00+07:00' },
    entryCount: '3',
    withdrawalCount: '2',
    createdAt: '2026-06-01T09:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-22T21:00:00+07:00',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  },
  {
    id: '00000000-0000-4000-8000-000000001002',
    partner: { id: '00000000-0000-4000-8000-000000000102', code: 'PARTNER-B', name: 'Partner B' },
    memberId: '00000000-0000-4000-8000-000000000302',
    partnerUserId: 'partner-user-b',
    username: 'affiliate-b',
    agent: null,
    status: 'SUSPENDED',
    currencyCode: 'USD',
    currencyMinorUnit: 2,
    availableBalance: '500.250000',
    reservedBalance: '75.000000',
    totalBalance: '575.250000',
    lifetimeEarned: '900.250000',
    lifetimeReversed: '25.000000',
    lifetimeAdjusted: '0.000000',
    lifetimeWithdrawn: '300.000000',
    lifetimeExpired: '0.000000',
    expiringBalance: '0.000000',
    nextExpiryAt: null,
    version: '8',
    lastEntryAt: '2026-07-20T14:00:00+07:00',
    reconciliation: { status: 'MISMATCHED', checkedAt: '2026-07-22T21:00:00+07:00' },
    entryCount: '1',
    withdrawalCount: '1',
    createdAt: '2026-06-15T10:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-20T14:00:01+07:00',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  },
]);

export const walletLedgerFixtures = Object.freeze<readonly WalletLedgerEntry[]>([
  {
    id: '00000000-0000-4000-8000-000000001101',
    walletId: walletFixtures[0]!.id,
    walletVersion: '42',
    entryType: 'AFFILIATE_EARN',
    amount: '1250.500000',
    availableBefore: '8999.500000',
    availableDelta: '1250.500000',
    availableAfter: '10250.000000',
    reservedBefore: '1500.000000',
    reservedDelta: '0.000000',
    reservedAfter: '1500.000000',
    earnedDelta: '1250.500000',
    reversedDelta: '0.000000',
    adjustedDelta: '0.000000',
    withdrawnDelta: '0.000000',
    expiredDelta: '0.000000',
    currencyCode: 'THB',
    currencyMinorUnit: 2,
    source: {
      commissionLedgerEntryId: '00000000-0000-4000-8000-000000000801',
      transactionId: '00000000-0000-4000-8000-000000000401',
      withdrawalId: null,
      walletAdjustmentId: null,
    },
    agent: agentA,
    username: 'affiliate-a',
    effectiveAt: '2026-07-22T08:00:00-04:00',
    createdAt: '2026-07-22T19:00:01+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
  },
  {
    id: '00000000-0000-4000-8000-000000001102',
    walletId: walletFixtures[0]!.id,
    walletVersion: '41',
    entryType: 'WITHDRAWAL_RESERVE',
    amount: '1500.000000',
    availableBefore: '10499.500000',
    availableDelta: '-1500.000000',
    availableAfter: '8999.500000',
    reservedBefore: '0.000000',
    reservedDelta: '1500.000000',
    reservedAfter: '1500.000000',
    earnedDelta: '0.000000',
    reversedDelta: '0.000000',
    adjustedDelta: '0.000000',
    withdrawnDelta: '0.000000',
    expiredDelta: '0.000000',
    currencyCode: 'THB',
    currencyMinorUnit: 2,
    source: {
      commissionLedgerEntryId: null,
      transactionId: null,
      withdrawalId: '00000000-0000-4000-8000-000000001201',
      walletAdjustmentId: null,
    },
    agent: agentA,
    username: 'affiliate-a',
    effectiveAt: '2026-07-21T17:00:00+07:00',
    createdAt: '2026-07-21T17:00:01+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
  },
  {
    id: '00000000-0000-4000-8000-000000001103',
    walletId: walletFixtures[0]!.id,
    walletVersion: '40',
    entryType: 'ADJUSTMENT',
    amount: '500.000000',
    availableBefore: '10999.500000',
    availableDelta: '-500.000000',
    availableAfter: '10499.500000',
    reservedBefore: '0.000000',
    reservedDelta: '0.000000',
    reservedAfter: '0.000000',
    earnedDelta: '0.000000',
    reversedDelta: '0.000000',
    adjustedDelta: '-500.000000',
    withdrawnDelta: '0.000000',
    expiredDelta: '0.000000',
    currencyCode: 'THB',
    currencyMinorUnit: 2,
    source: {
      commissionLedgerEntryId: null,
      transactionId: null,
      withdrawalId: null,
      walletAdjustmentId: '00000000-0000-4000-8000-000000001301',
    },
    agent: agentA,
    username: 'affiliate-a',
    effectiveAt: '2026-07-20T12:00:00+07:00',
    createdAt: '2026-07-20T12:00:01+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
  },
]);
